import { render, staticRenderFns } from "./service.vue?vue&type=template&id=04cb9088&"
import script from "./service.vue?vue&type=script&lang=ts&"
export * from "./service.vue?vue&type=script&lang=ts&"
import style0 from "./service.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCardTitle,VImg})
